/**
 * **Download the Codex macro** (2.I-2 deliverable 18): a link to `foundry.macro.get`'s path with
 * `download="codex-export.js"`, beside how to run it. In the import page's "Foundry's own numbers"
 * panel and in Settings.
 */
import { macroHref } from './href.js';
import { MACRO_TEXT } from './model/copy.js';
import './foundry.css';

export function MacroLink() {
  return (
    <p className="cx-foundry-macro">
      <a
        className="cx-foundry__link"
        href={macroHref()}
        download={MACRO_TEXT.file}
        data-testid="foundry.macro.download"
      >
        {MACRO_TEXT.link}
      </a>{' '}
      <span>{MACRO_TEXT.how}</span>
    </p>
  );
}
